import { combineReducers } from 'redux';
import productReducer from './productReducer'
import InvestPlanReducer from './myAssets/InvestPlanReducer'
import myInvestReducer from './myAssets/myInvestReducer'
import TransformationReducer from './TransformationReducer'
import serviceReportReducer from './serviceReportReducer'
import {allIncomeLast,lineDataLast,investNot,stopProfitDetail,superFundProductIncomes,lineData,strategiesDetails,changeFundList,userAllIncomeHistory} from './protfolioReducer'
const isLogin = (state =false, action) => {
  switch(action.type) {
    case "IS_LOGIN":
      return action.text; 
    default: 
      return state;
  }
}
////同步开户传入参数：证件类型
const loginType = (state = '', action) => {
  switch(action.type) {
    case "SYNC_ACCOUNT_LOGIN_TYPE":
      return action.text; 
    default: 
      return state;
  }
}

/*基金历史收益/净值*/
function fundHistoryRatePage(state = {HistoryRate:[],totalElements:0}, action) {
  if(action.type ===  "FUND_HISTORY_RATE_PAGE"){
    return action.text; 
  }else{
    return state;
  }
}

////同步开户传入参数：证件号码
const loginNo = (state = '', action) => {
  switch(action.type) {
    case "SYNC_ACCOUNT_LOGIN_NO":
      return action.text; 
    default: 
      return state;
  }
}

////同步开户传入参数：交易密码
const tradePassword = (state = '', action) => {
  switch(action.type) {
    case "SYNC_ACCOUNT_TRADE_PASSWORD":
      return action.text; 
    default: 
      return state;
  }
}

////同步开户传入参数：登录密码
const loginPassword = (state = '', action) => {
  switch(action.type) {
    case "SYNC_ACCOUNT_LOGIN_PASSWORD":
      return action.text;
    default: 
      return state;
  }
}

////同步开户传入参数：手机号
const mobileNo = (state = '', action) => {
  switch(action.type) {
    case "SYNC_ACCOUNT_MOBILE_NO":
      return action.text; 
    default: 
      return state;
  }
}

////同步开户传入参数：短信请求编码
const requestId = (state = '', action) => {
  switch(action.type) {
    case "SYNC_ACCOUNT_REQUEST_ID":
      return action.text; 
    default: 
      return state;
  }
}

////同步开户传入参数：短信请求编码
const name = (state = '', action) => {
  switch(action.type) {
    case "SYNC_ACCOUNT_NAME":
      return action.text; 
    default: 
      return state;
  }
}
////同步开户传入参数：邀请码
const invitationCode = (state = '', action) => {
  switch(action.type) {
    case "INVITATION_CODE":
      return action.text; 
    default: 
      return state;
  }
}
/*智投首页*/
function SupperFundHome(state = null, action) {
  switch(action.type) {
    case "SUPPER_FUND_HOME":
      return action.text; 
    default: 
      return state;
  }
}
const riskModalData = (state = null, action)=>{
  switch(action.type){
    case 'RISK_MODAL_DATA':
      return action.text;
    default:
      return state;
  }
}
const payLoading = (state = false, action)=>{
  switch(action.type){
    case 'SET_PAY_LOADING':
      return action.text;
    default:
      return state;
  }
}
//银行 活期通选中位置
function selectBankIndex(state=0, action) {
  switch(action.type) {
    case "SELECTED_BANK_INDEX":
      return action.text; 
    default: 
      return state;
  }
}
function selectCurrentIndex(state=0, action) {
  switch(action.type) {
    case "SELECTED_CURRENT_INDEX":
      return action.text; 
    default: 
      return state;
  }
}

function currentType(state=1, action) {
  switch(action.type) {
    case "CURRENT_TYPE":
      return action.text; 
    default: 
      return state;
  }
}
function currentIndex(state=0, action) {
  switch(action.type) {
    case "CURRENT_INDEX":
      return action.text; 
    default: 
      return state;
  }
}
function currencyIndex(state=0, action) {
  switch(action.type) {
    case "CURRENCY_INDEX":
      return action.text; 
    default: 
      return state;
  }
}
function targetIndex(state=0, action) {
  switch(action.type) {
    case "TARGET_INDEX":
      return action.text;
    default:
      return state;
  }
}
//当前选中卡券类型 true选中银行
function bankOrCurrent(state=false, action) {
  switch(action.type) {
    case "BANK_OR_CURRENT":
      return action.text; 
    default: 
      return state;
  }
}
//支付
function payInfo(state={code:'',message:'',content:{currencyFund:[],shareList:[],currentAccountList:[],currentNav:'',currentNavDate:'',fundCode:'',fundName:'',minAmount:''}}, action) {
  switch(action.type) {
    case "PAY_INFO":
      return action.text; 
    default: 
      return state;
  }
}
function generateReducer(prefix,state){
  console.log(prefix,state,22002222);
  const PAY_INFO=prefix+'_PAY_INFO'
  let initialState={code:'',message:'',content:{currencyFund:[],shareList:[],currentAccountList:[],...state},currentType:4,currentIndex:0}
  return function payInfoReducer(state=initialState, action) {
    switch(action.type) {
      case PAY_INFO:
        return action.text; 
        break;
      default: 
        return state;
        break;
    }
  }
}
function currentAccount(state={code:'',message:'',content:{shareList:[],currentAccountList:[]}}, action) {
  switch(action.type) {
    case "CURRENT_ACCOUNT":
      return action.text; 
    default: 
      return state;
  }
}
//说明书选择状态
function smSzt(state=0, action) {
  switch(action.type) {
    case "SMS_ZT":
      return action.text; 
    default: 
      return state;
  }
}
//活期通选中状态
function hqtXz(state=0, action) {
  switch(action.type) {
    case "HQT_XZ":
      return action.text; 
    default: 
      return state;
  }
}
//费率
function rateAndFee(state={code:'',message:'',content:{fee:'--',feeBefore:'--',rate:'--',rate4:'--',rateBefore:'--'}}, action) {
  switch(action.type) {
    case "RATE_AND_FEE":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
//季度调仓
function inSeasonDetail(state={fee:'',needDays:'',previewItemFunds:[],previewItemFundsChart:[],superFund:{createDate:'',riskTypeName:'',fundName:'',nextAdjustDate:''},targetSuperFund:{}}, action) {
  switch(action.type) {
    case "SEASON_DETAIL":
      return action.text; 
    default: 
      return state;
  }
}
//是否需要调仓

function userHasInvested(state=false, action) {
  switch(action.type) {
    case "QUERY_INCOME":
      return action.text; 
    default: 
      return state;
  }
}
function inNeedUpdate(state=false, action) {
  switch(action.type) {
    case "NEED_UPDATE":
      return action.text; 
    default: 
      return state;
  }
}
function inNeedNotice(state=false, action) {
  switch(action.type) {
    case "NEED_NOTICE":
      return action.text; 
    default: 
      return state;
  }
}

//智投百科
function encyclopediaAction(state = null, action) {
  switch(action.type) {
    case "ENCYCLOPEDIA_ACTION":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
//风险测评数据
function riskEvaluationPieData(state = null, action) {
  switch(action.type) {
    case "RISK_EVALUATIONPIE_DATA":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}

function webViewHtml(state='', action) {
  switch(action.type) {
    case "WEB_VIEW_HTML":
      return action.text; 
    default: 
      return state;
  }
}
//转换基金列表
function TransformationFunList(state={code:'',message:'',content:[]}, action) {
  switch(action.type) {
    case "TRANSFORMATION_FUN_LIST":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
//ydx end

/*智投组合未投 详情*/
function InvestNotCombinationDetil(state = null, action) {
  switch(action.type) {
    case "INVES_NOT_COMBINATION":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
/*组合已投资详情*/
function InvestStopDetil(state = null, action) {
  switch(action.type) {
    case "INVEST_STOP":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
//职业列表
function userJob(state = null, action) {
  switch(action.type) {
    case "USER_JOB":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
//城市列表
function provinceCity(state = null, action) {
  switch(action.type) {
    case "PROVINCE_CITY":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}


/*操作记录*/
function QueryTradeRecords(state = null, action) {
  switch(action.type) {
    case "QUERY_TRADE_RECORDS":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}

//银行卡列表
function bankList(state = null, action) {
  switch(action.type) {
    case "BANK_LIST":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
//银行卡类型
function bankType(state = null, action) {
  switch(action.type) {
    case "BANK_TYPE":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
//鉴权返回流水号
function checkNumber(state = null, action) {
  switch(action.type) {
    case "CHECK_NUMBER":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
function dianji(state = null, action) {
  switch(action.type) {
    case "DIANJI":
      return action.text?action.text:1; 
      break;
    default: 
      return state;
      break;
  }
}
//鉴权确认
function checkSuccessData(state = null, action) {
  switch(action.type) {
    case "CHECK_SUCCESS_DATA":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}



/*在途资金明细*/
function QueryTransitRecords(state = null, action) {
  switch(action.type) {
    case "QUERY_TRANSIT_RECORDS":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}

/*交易记录详情*/
function getTradeDetail(state = null, action) {
  switch(action.type) {
    case "TRADE_DETAIL":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
/*state 状态*/
function openFlag(state = 0, action) {
  switch(action.type) {
    case "OPEN_FLAG":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
function active(state = 1, action) {
  switch(action.type) {
    case "ACTIVE":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
function addCardText(state = '', action) {
  switch(action.type) {
    case "ADD_CARD_TEXT":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
function addPhoneText(state = '', action) {
  switch(action.type) {
    case "ADD_PHONE_TEXT":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
function paymentText(state = '', action) {
  switch(action.type) {
    case "PAYMENT_TEXT":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
function paymentTextDT(state = '', action) {
  switch(action.type) {
    case "PAYMENT_TEXT_DT":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
function paymentAgree(state = 0, action) {
  switch(action.type) {
    case "PAYMENT_AGREE":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
function fee(state = '--', action) {
  switch(action.type) {
    case "FEE":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}

function phoneNum(state = '', action) {
  switch(action.type) {
    case "PHONE_NUM":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}

function verifyCode(state = '', action) {
  switch(action.type) {
    case "VERIFY_CODE":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
function syncLoginPWD1(state = '', action) {
  switch(action.type) {
    case "SYNC_LOGIN_PWD1":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}

function syncLoginPWD2(state = '', action) {
  switch(action.type) {
    case "SYNC_LOGIN_PWD2":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
function syncDealPWD1(state = '', action) {
  switch(action.type) {
    case "SYNC_DEAL_PWD1":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
function syncDealPWD2(state = '', action) {
  switch(action.type) {
    case "SYNC_DEAL_PWD2":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
function syncBtn(state ={agreeIndex1:0,agreeIndex2:0,btnFlag:false}, action) {
  switch(action.type) {
    case "SYNC_BTN":
      if (action.text==1) {
        if (state.agreeIndex1==0&&state.agreeIndex2==1) 
          return {agreeIndex1:state.agreeIndex1==0?1:0,agreeIndex2:state.agreeIndex2,btnFlag:true};
        else
          return {agreeIndex1:state.agreeIndex1==0?1:0,agreeIndex2:state.agreeIndex2,btnFlag:false};
      }else if(action.text==2){
        if (state.agreeIndex1==1&&state.agreeIndex2==0) 
          return {agreeIndex1:state.agreeIndex1,agreeIndex2:state.agreeIndex2==0?1:0,btnFlag:true};
        else
          return {agreeIndex1:state.agreeIndex1,agreeIndex2:state.agreeIndex2==0?1:0,btnFlag:false};
      }else{
        return {agreeIndex1:0,agreeIndex2:0,btnFlag:false}
      }
      break;
    default: 
      return state;
      break;
  }
}

//养老教育储备金
function yljycbMoney(state=null, action) {
  switch(action.type) {
    case "YLJYCB_MONEY":
      return action.text; 
    default: 
      return state;
  }
}
//预期养老教育金
function yqyljyMoney(state=null, action) {
  switch(action.type) {
    case "YQYLJY_MONEY":
      return action.text; 
    default: 
      return state;
  }
}
//预期养老教育金2
function yqyljySliderVal(state=null, action) {
  switch(action.type) {
    case "YQYLJY_SLIDER_VAL":
      return action.text; 
    default: 
      return state;
  }
}
//养老教育年龄
function yljyAge(state=null, action) {
  switch(action.type) {
    case "YLJY_AGE":
      return action.text; 
    default: 
      return state;
  }
}
//养老退休年龄
function ylOutAge(state=null, action) {
  switch(action.type) {
    case "YL_OUTAGE":
      return action.text; 
    default: 
      return state;
  }
}
//养老教育投资方案
function yljyPlan(state=null, action) {
  switch(action.type) {
    case "YLJY_PLAN":
      return action.text; 
    default: 
      return state;
  }
}

//养老教育指数
function yljyNum(state=null, action) {
  switch(action.type) {
    case "YLJY_NUM":
      return action.text; 
    default: 
      return state;
  }
}
//养老教育投入金额
function yljyAllMoney(state=null, action) {
  switch(action.type) {
    case "YLJY_ALL_MONEY":
      return action.text; 
    default: 
      return state;
  }
}
//养老教育金额图表
function yljyLineData(state=null, action) {
  switch(action.type) {
    case "YLJY_LINE_DATA":
      return action.text; 
    default: 
      return state;
  }
}
//教育学校类型
function jySchoolType(state=null, action) {
  switch(action.type) {
    case "JY_SCHOOL_TYPE":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证持卡人
function smrzCardPerson(state=null, action) {
  switch(action.type) {
    case "SMRZ_CARD_PERSON":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证身份证号
function smrzPersonNumber(state=null, action) {
  switch(action.type) {
    case "SMRZ_PERSON_NUMBER":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证地址
function smrzAddress(state=null, action) {
  switch(action.type) {
    case "SMRZ_ADDRESS":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证控制人地址
function smrzkzrAddress(state=null, action) {
  switch(action.type) {
    case "SMRZ_KZRADDRESS":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证受益人地址
function smrzsyrAddress(state=null, action) {
  switch(action.type) {
    case "SMRZ_SYRADDRESS":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证控制人邮政编码
function smrzkzrBianma(state=null, action) {
  switch(action.type) {
    case "SMRZ_KZRBIANMA":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证受益人邮政编码
function smrzsyrBianma(state=null, action) {
  switch(action.type) {
    case "SMRZ_SYRBIANMA":
      return action.text; 
    default: 
      return state;
  }
}

//实名认证控制人电子邮箱
function smrzkzrYoux(state=null, action) {
  switch(action.type) {
    case "SMRZ_KZRYOUX":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证受益人电子邮箱
function smrzsyrYoux(state=null, action) {
  switch(action.type) {
    case "SMRZ_SYRYOUX":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证职业
function smrzJob(state=[""], action) {
  switch(action.type) {
    case "SMRZ_JOB":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证控制人职业
function smrzkzrJob(state=[""], action) {
  switch(action.type) {
    case "SMRZ_KZRJOB":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证受益人职业
function smrzsyrJob(state=[""], action) {
  switch(action.type) {
    case "SMRZ_SYRJOB":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证职业代码
function smrzCareerCode(state=[""], action) {
  switch(action.type) {
    case "SMRZ_CAREERCODE":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证控制人职业代码
function smrzCareerkzrCode(state=[""], action) {
  switch(action.type) {
    case "SMRZ_CAREERKZRCODE":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证受益人职业代码
function smrzCareersyrCode(state=[""], action) {
  switch(action.type) {
    case "SMRZ_CAREERSYRCODE":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证年收入
function smrznsrcode(state=[""], action) {
  switch(action.type) {
    case "SMRZ_NSRCODE":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证具体年收入
function smrznJtsrcode(state=[""], action) {
  switch(action.type) {
    case "SMRZ_JTNSRCODE":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证城市
function smrzCity(state=["", ""], action) {
  switch(action.type) {
    case "SMRZ_CITY":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证控制人城市
function smrzkzrCityc(state=["", ""], action) {
  switch(action.type) {
    case "SMRZ_KZRCITY":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证受益人城市
function smrzsyrCityc(state=["", ""], action) {
  switch(action.type) {
    case "SMRZ_SYRCITY":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证控制人类型
function smrzBeneficontro(state=["本人"], action) {
  switch(action.type) {
    case "SMRZ_BENEFCONTRO":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证控制人
function smrzBeneficontroName(state=null, action) {
  switch(action.type) {
    case "SMRZ_BENEFCONTRO_NAME":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证控制人证件有效期
function smrzBeneficontroZjyxq(state=null, action) {
  switch(action.type) {
    case "SMRZ_BENEFCONTRO_ZJYXQ":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证主账户证件有效期
function zzhZjyxq(state=null, action) {
  switch(action.type) {
    case "ZZH_ZJYXQ":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证受益人证件有效期
function smrzBeneficiariesZjyxq(state=null, action) {
  switch(action.type) {
    case "SMRZ_BENEFICIARIES_ZJYXQ":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证控制人证件照片
function smrzBeneficontroZjzq(state=null, action) {
  switch(action.type) {
    case "SMRZ_BENEFCONTRO_ZJZQ":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证控制人证件照片
function smrzBeneficiariesZjzq(state=null, action) {
  switch(action.type) {
    case "SMRZ_BENEFICIARIES_ZJZQ":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证控制人性别
function smrzkzrXbcode(state=null, action) {
  switch(action.type) {
    case "SMRZ_BENEFCONTRO_XBCODE":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证受益人性别
function smrzsyrXbcode(state=null, action) {
  switch(action.type) {
    case "SMRZ_BENEFICIARIES_XBCODE":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证控制人出生日期
function smrzBeneficontroCsrq(state=null, action) {
  switch(action.type) {
    case "SMRZ_BENEFICIARIES_CSRQ":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证受益人出生日期
function smrzBeneficiariesCsrq(state=null, action) {
  switch(action.type) {
    case "SMRZ_BENEFCONTRO_CSRQ":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证控制人手机号
function smrzBeneficontroKzrNo(state=null, action) {
  switch(action.type) {
    case "SMRZ_BENEFCONTRO_KZRNO":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证受益人手机号
function smrzBeneficontroSyrNo(state=null, action) {
  switch(action.type) {
    case "SMRZ_BENEFICIARIES_SYRNO":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证受益人类型
function smrzBeneficiaries(state=["本人"], action) {
  switch(action.type) {
    case "SMRZ_BENEFICIARIES":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证受益人
function smrzBeneficiariesName(state=null, action) {
  switch(action.type) {
    case "SMRZ_BENEFICIARIES_NAME":
      return action.text; 
    default: 
      return state;
  }
}
function huiDiao(state=null, action) {
  switch(action.type) {
    case "HUIDIAO":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证受益人证件类型
function smrzBeneficiariesType(state=[""], action) {
  switch(action.type) {
    case "SMRZ_BENEFICIARIES_TYPE":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证控制人证件类型
function smrzBeneficontroType(state=[""], action) {
  switch(action.type) {
    case "SMRZ_BENEFCONTRO_TYPE":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证受益人证件号
function smrzBeneficiariesNo(state=null, action) {
  switch(action.type) {
    case "SMRZ_BENEFICIARIES_NO":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证控制人证件号
function smrzBeneficontroNo(state=null, action) {
  switch(action.type) {
    case "SMRZ_BENEFCONTRO_NO":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证组织
function smrzGjzz(state=["否"], action) {
  switch(action.type) {
    case "SMRZ_GJZZ":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证银行卡号
function smrzCardNumber(state=null, action) {
  switch(action.type) {
    case "SMRZ_CARD_NUMBER":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证修改手机号
function smrzUpdatePhoneNo(state=null, action) {
  switch(action.type) {
    case "SMRZ_UPDATE_PHONE_NO":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证同意项
function smrzAgreeItemFlag(state=null, action) {
  switch(action.type) {
    case "SMRZ_AGREE_ITEM_FLAG":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证验证码
function smrzCheckCard(state=null, action) {
  switch(action.type) {
    case "SMRZ_CHECK_CARD":
      return action.text; 
    default: 
      return state;
  }
}
//实名认获取证验证码显示文字
function smrzCheckCardText(state=null, action) {
  switch(action.type) {
    case "SMRZ_CHECK_CARD_TEXT":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证验证码状态
function smrzCheckCardFlag(state=null, action) {
  switch(action.type) {
    case "SMRZ_CHECK_CARD_FLAG":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证交易密码
function smrzPassWord(state="", action) {
  switch(action.type) {
    case "SMRZ_PASS_WORD":
      return action.text; 
    default: 
      return state;
  }
}
//实名认证确认交易密码
function smrzPassWordAgain(state="", action) {
  switch(action.type) {
    case "SMRZ_PASS_WORD_AGAIN":
      return action.text; 
    default: 
      return state;
  }
}

//基金标签 - zbw
function fundLabel(state = null, action) {
  switch(action.type) {
    case "FUND_LABEL":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
//公募基金列表 - zbw
function fundListGm(state = null, action) {
  switch(action.type) {
    case "FUND_LIST_GM":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
//公募基金列表 - zbw
function fundListGm2(state = null, action) {
  switch(action.type) {
    case "FUND_LIST_GM2":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
//私募基金列表 - zbw
function fundListSm(state = null, action) {
  switch(action.type) {
    case "FUND_LIST_SM":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
//券商集合列表 - zbw
function fundListJh(state = null, action) {
  switch(action.type) {
    case "FUND_LIST_JH":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
//优选专户列表 - zbw
function fundListZh(state = null, action) {
  switch(action.type) {
    case "FUND_LIST_ZH":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
//基金搜索列表 - zbw
function searchFundList(state = null, action) {
  switch(action.type) {
    case "SEARCH_FUND_LIST":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}

const userId = (state = '', action)=>{
  // console.log('reducer userId', action && action.text ? action.text : state);
  switch(action.type) {
    case "TEMP_INFO_USER_ID":
      return action.text; 
    default: 
      return state;
  }
}

const shortToken = (state = {shortToken: '', timeLine: ''}, action)=>{
  // console.log('reducer shortToken',action && action.text ? action.text : state);
  switch(action.type) {
    case "TEMP_INFO_SHORT_TOKEN":
      return action.text; 
    default: 
      return state;
  }
}

const longToken = (state = '', action)=>{
  // console.log('reducer longtoken',action && action.text ? action.text : state);
  switch(action.type) {
    case "TEMP_INFO_LONG_TOKEN":
      return action.text; 
    default: 
      return state;
  }
}

const tradeAccountNo = (state= '', action)=>{
  switch(action.type){
    case 'TEMP_INFO_TRADE_ACCOUNT_NO':
      return action.text;
    default: 
      return state;
  }
}

const nickName = (state = null, action)=>{
  switch(action.type){
    case 'TEMP_INFO_NICK_NAME':
      return action.text;
    default: 
      return state
  }
}

const userName = (state = null, action)=>{
  switch(action.type){
    case 'TEMP_INFO_USER_NAME':
      return action.text;
    default:
      return state;
  }
}

const trueName = (state = null, action)=>{
  switch(action.type){
    case 'TEMP_INFO_TRUE_NAME':
      return action.text;
    default:
      return state;
  }
}

const userMobileNo = (state = null, action)=>{
  switch(action.type){
    case 'TEMP_INFO_USER_MOBILE_NO':
      return action.text;
    default:
      return state;
  }
}

const isPrivate = (state = null, action)=>{
  switch(action.type){
    case 'TEMP_INFO_IS_PRIVATE':
      return action.text;
    default:
      return state;
  }
}

const bankCardListResetPS = (state = [], action)=>{
  switch(action.type){
    case 'BANK_CARD_LIST_RESET':
      return action.text;
    default:
      return state;
  }
}

//产品类型
const productListType = (state = null, action)=>{
  switch(action.type){
    case 'PRODUCT_LIST_TYPE':
      return action.text;
    default:
      return state;
  }
}

//资产集合
const incomeDigital = (state = {customerTotalValue: '--', dayIncome: '--', allIncome: '--', endDate: '- -', transitTotalValue: '--'}, action)=>{
  switch(action.type){
    case 'MY_ASSETS_INCOME_DIGITAL':
      return action.text;
    default:
      return state;
  }
}

//实名个人信息
function verifiedUserInfo(state = null, action){
  switch(action.type) {
    case "VERIFIEDUSERINFO":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}

/*夏基金用户是否存在以及获取用户信息*/
function findHqtExist(state=false, action) {
  switch(action.type) {
    case "HQT_EXIST":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}

function hqtCardList(state=[], action) {
  switch(action.type) {
    case "HQT_CARD_LIST":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}

function Xeyi(state=[], action) {
  switch(action.type) {
    case "XEYI":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}

/*公募基金详情*/
function fundPublicProductDetil(state = {
  PublicDetilAllocation:[],
  PublicDetilAsset:[],
  PublicDetilBaseInfo:[{
    managers:"",
  }],
  PublicDetilBond:[],
  PublicDetilInfo:[{discount_rate:"",dtstatus:"",
                  fundcode:"",fundenddate:null,
                  fundfullname:"",fundmessage:"",
                  fundname:"",fundstartdate:"",
                  fundtype:"",fundvalue:"",
                  isshow:null,leijijingzhi:"",numcolor:"",
                  publish_date:"",qirinianhua:null,
                  qrnhcolor:"",rate:"",sgstatus:"",
                  show_discount_rate:"",
                  tradedt:"",tradesg:"",wanfenshouyi:null,
                  year3grade:"",year5grade:"",zhangdiefu:"",
                  tradedt:"",
  }],
  PublicDetilManager:[],
  PublicDetilProfit:[{
    fundcode:"",fundname:"",fundtype:""
    ,m1:"",m3:"",m6:"",sumdate:"",
    totalnavchgrate:null,w1:"",y1:"",y2:null,y3:"",y4:null,
    y5:"",yearnavchgrate:null
  }],
  PublicDetilRate:[],
  PublicDetilStock:[]
}, action) {
  switch(action.type) {
    case "FUND_PUBLIC_DETIL":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
/*私募基金详情*/
function fundPrivateProductDetil(state = {
  announcement:null,asset:null,asset_date:"",buy_rare:"1",chg:null,
  create_date:"",cxq:"",fund_code:"",
  fund_introduce:"null",fund_level:null,fund_management:"null",
  fund_name:"",fund_operator:"",fund_style:"",fund_t:null,fund_type:"私募基金",
  id:"2552",invest_extent:"",nvest_manager:"",
  invest_manager_introduce:null,invest_strategy:"",investment_term:"null",
  is_optional:"0",join_rare:"",kfq:"",manager:"",
  minAmount:null,nav_actual_date:"2016-02-01",
  open_date_end:"2017-01-20",
  open_date_start:"2017-01-04",
  operator:null,
  proformance_wage:"",
  publish_date:"2017-01-23",
  risk_type:null,
  short_name:"",
  start_money:"",
  start_point:null,
  state:"1",
  trusteeship:"",
  y1:null,
  y1_name:"",
  y1_order:null
}, action) {
  switch(action.type) {
    case "FUND_PRIVATE_RATE":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}

/*集合理财详情*/
function fundAggregateProductDetil(state = {
  announcement:null,asset:null,asset_date:"",buy_rare:"1",chg:null,
  create_date:"",cxq:"不定期",fund_code:"",
  fund_introduce:"null",fund_level:null,fund_management:"null",
  fund_name:" ",fund_operator:"",fund_style:"",fund_t:null,fund_type:"私募基金",
  id:"2552",invest_extent:"",nvest_manager:"",
  invest_manager_introduce:null,invest_strategy:"",investment_term:"null",
  is_optional:"0",join_rare:"",kfq:"",manager:"",
  minAmount:null,nav_actual_date:"2016-02-01",
  open_date_end:"2017-01-20",
  open_date_start:"2017-01-04",
  operator:null,
  proformance_wage:"",
  publish_date:"2017-01-23",
  risk_type:null,
  short_name:" ",
  start_money:"",
  start_point:null,
  state:"1",
  trusteeship:"",
  y1:null,
  y1_name:"",
  y1_order:null
}, action) {
  switch(action.type) {
    case "FUND_AGGREGATE_RATE":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}

/*基金历史净值*/
function fundHistoty(state = {HistoryRate:[],totalElements:0}, action) {
  switch(action.type) {
    case "FUND_HISTORY_RATE":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
/*自选标示*/
function AddZxFlag(state = null, action){
  switch(action.type) {
    case "Add_ZX":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}

function getHistoryAdjust(state = null, action) {
  switch(action.type) {
    case "HISTORY_DETAIL":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}

//文章详情
function articleDetail(state = [], action) {
  switch(action.type) {
    case "ARTICLE_DETAIL":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}

//评论列表
function articleMessageList(state = [], action) {
  switch(action.type) {
    case "ARTICLE_MESSAGE_LIST":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}

/*智投产品 查询是否开放升级功能 */
function validateSuperFundUpdate(state=false, action) {
  switch(action.type) {
    case "VALIDATE_SUPERFUND_UPDATE_ACTION":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}

/*智投升级预览*/
function redeemToSuperFundPreview(state={
  fee: "",
  needDays: "",
  previewItemFunds:[],
  superFund:{
    createDate: "",
    fundName: "",
    fundType: "",
    itemList:[],
    nextAdjustDate:"",
    riskType:"",
    riskTypeName:"",
    superFundCode:""
  },
  targetSuperFund:{
    createDate: "",
    fundName: "",
    fundType: "",
    itemList:[],
    nextAdjustDate:"",
    riskType:"",
    riskTypeName:"",
    superFundCode:""
  },
  previewItemFundsChart:[]
}, action) {
  switch(action.type) {
    case "REDEEM_TO_SUPER_FUND_PREVIEW":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}


/*投顾状态*/
function superFundAccAgreementState(state=false, action) {
  switch(action.type) {
    case "SUPER_ACCA_AGREEMENT_STATE":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
/*签约状态*/
function signingAlreadyState(state={tradeAccountNo: "", state: "", createTime: 0, lastUpdateTime: 0}, action) {
  switch(action.type) {
    case "SIGNING_ALREADY_STATE":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
/**智投升级控制标识 */
function upgradeControl(state=false,action) {
  switch(action.type) {
    case "UPGRADE_CONTROL":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
//答题ID
function setActivityId(state = {activityId:""}, action) {
  switch(action.type) {
    case "ACTIVITY_ID":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
//智投组合小常乐详情
function SuperFoundDetailXCL(state = [], action) {
  switch(action.type) {
    case "SUPERFUND_DETAIL_XCL":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}
let reducers = combineReducers({
  SuperFoundDetailXCL,
  hqtCardList,
  Xeyi,
  findHqtExist,
  upgradeControl,
  signingAlreadyState,
  superFundAccAgreementState,
  validateSuperFundUpdate,
  redeemToSuperFundPreview,
  /*历史调仓*/
  getHistoryAdjust,
  /*state 状态*/
  isLogin,
  syncBtn,
  syncLoginPWD1,
  syncLoginPWD2,
  syncDealPWD1,
  syncDealPWD2,
  paymentAgree,
  fee,
  paymentText,
  paymentTextDT,
  active,
  openFlag,
  addCardText,
  addPhoneText,
  phoneNum,
  verifyCode,
  TransformationFunList,
  /*智投首页*/
  riskModalData,
  payLoading,
  InvestNotCombinationDetil,/*智投未投 详情*/
  InvestStopDetil,/*智投已投资详情*/
  QueryTradeRecords,/*操作记录*/
  getTradeDetail,/*交易记录详情*/
  QueryTransitRecords,/*在途资金明细*/
  SupperFundHome,/*智投首页*/
  fundPublicProductDetil,/*公募详情*/
  fundPrivateProductDetil,/*私募详情*/
  fundAggregateProductDetil,/*集合理财*/
  fundHistoty,/*历史净值*/
  AddZxFlag,/*自选标示*/
  selectBankIndex,//卡位置
  selectCurrentIndex,//活期通位置
  bankOrCurrent,//卡类型
  currentIndex,
  currencyIndex,
  currentType,
  payInfo,//支付渠道
  smSzt,
  hqtXz,
  buyFundPayInfo:generateReducer('BUY_FUND'),
  bugDTPayInfo:generateReducer('BUY_DT'),
  superFundPayInfo:generateReducer('SUPER_FUND'),
  superFundDTPayInfo:generateReducer('SUPER_FUND_DT'),
  hqtPayInfo:generateReducer('HQT'),
  currentAccount,
  rateAndFee,//申购费率
  inSeasonDetail,//调仓info
  userHasInvested,
  inNeedUpdate,
  inNeedNotice,
  loginType,
  loginNo,
  verifiedUserInfo,
  tradePassword,
  loginPassword,
  mobileNo,
  requestId,
  name,
  //智投百科
  encyclopediaAction,
  //风险偏好测评
  riskEvaluationPieData,
  //职业列表
  userJob,
  //城市列表
  provinceCity,
  //银行卡列表
  bankList,
  //银行卡类型
  bankType,
  //鉴权流水号
  checkNumber,
  dianji,
  //鉴权确认
  checkSuccessData,
  webViewHtml,
  //养老教育储备金
  yljycbMoney,
  //预期养老教育金
  yqyljyMoney,
  //预期养老教育金2
  yqyljySliderVal,
  //养老教育年龄
  yljyAge,
  //养老退休年龄
  ylOutAge,
  //养老教育投资方案
  yljyPlan,
  //养老教育指数
  yljyNum,
  //养老教育投入金额
  yljyAllMoney,
  //养老教育金额图表
  yljyLineData,
  //教育学校类型
  jySchoolType,
  //实名认证持卡人
  smrzCardPerson,
  //实名认证身份证号
  smrzPersonNumber,
  //实名认证地址
  smrzAddress,
  //实名认证控制人地址
  smrzkzrAddress,
  //实名认证受益人地址
  smrzsyrAddress,
  //实名认证控制人邮政编码
  smrzkzrBianma,
  //实名认证受益人邮政编码
  smrzsyrBianma,
  //实名认证控制人电子邮箱
  smrzkzrYoux,
  //实名认证受益人电子邮箱
  smrzsyrYoux,
  //实名认证职业
  smrzJob,
  //实名认证控制人职业
  smrzkzrJob,
  //实名认证受益人职业
  smrzsyrJob,
  //实名认证职业代码
  smrzCareerCode,
  //实名认证控制人职业代码
  smrzCareerkzrCode,
  //实名认证受益人职业代码
  smrzCareersyrCode,
  //实名认证具体年收入
  smrznJtsrcode,
  //实名认证年收入
  smrznsrcode,
  //实名认证城市
  smrzCity,
  //实名认证控制人城市
  smrzkzrCityc,
  //实名认证受益人城市
  smrzsyrCityc,
  //实名认证受益人类型
  smrzBeneficiaries,
  //实名认证受益人
  smrzBeneficiariesName,
  huiDiao,
  //实名认证控制人类型
  smrzBeneficontro,
  //实名认证控制人
  smrzBeneficontroName,
  //实名认证控制人证件有效期
  smrzBeneficontroZjyxq,
  // 实名认证主账户证件有效期
  zzhZjyxq,
  //实名认证受益人证件有效期
  smrzBeneficiariesZjyxq,
  //实名认证控制人证件照片
  smrzBeneficontroZjzq,
  //实名认证受益人证件照片
  smrzBeneficiariesZjzq,
  //实名认证控制人性别
  smrzkzrXbcode,
  //实名认证受益人性别
  smrzsyrXbcode,
  //实名认证控制人出生日期
  smrzBeneficontroCsrq,
  //实名认证受益人出生日期
  smrzBeneficiariesCsrq,
  //实名认证控制人手机号
  smrzBeneficontroKzrNo,
  //实名认证受益人手机号
  smrzBeneficontroSyrNo,
  //实名认证受益人证件类型
  smrzBeneficiariesType,
  //实名认证控制人证件类型
  smrzBeneficontroType,
  //实名认证受益人证件号
  smrzBeneficiariesNo,
  //实名认证控制人证件号
  smrzBeneficontroNo,
  //实名认证组织
  smrzGjzz,
  //实名认证银行卡号
  smrzCardNumber,
  //实名认证修改手机号
  smrzUpdatePhoneNo,
  //实名认证同意项
  smrzAgreeItemFlag,
  //实名认证验证码
  smrzCheckCard,
  //实名认获取证验证码显示文字
  smrzCheckCardText,
  //实名认证验证码状态
  smrzCheckCardFlag,
  //实名认证交易密码
  smrzPassWord,
  //实名认证确认交易密码
  smrzPassWordAgain,
  productReducer,//产品reducer
  //产品列表start
  fundLabel,
  fundListGm,
  fundListGm2,
  fundListSm,
  fundListJh,
  fundListZh,
  searchFundList,
  //产品列表end
  InvestPlanReducer,//定投reducer
  myInvestReducer,// 我的投资reduce
  TransformationReducer,//转换交易 记录信息
  userId,
  tradeAccountNo,
  nickName,
  userName,
  userMobileNo,
  isPrivate,
  shortToken,
  longToken,
  trueName,
  //产品类型
  productListType,
  //资产集合
  incomeDigital,
  bankCardListResetPS,
  //同步开户邀请码
  invitationCode,
    //文章详情
  articleDetail,
  //评论列表
  articleMessageList,
  targetIndex,
  setActivityId,
  serviceReportReducer,
  investNot,stopProfitDetail,superFundProductIncomes,
  lineData,strategiesDetails,changeFundList,userAllIncomeHistory,lineDataLast,allIncomeLast,
  fundHistoryRatePage
});

export default reducers;


// WEBPACK FOOTER //
// ./src/reducer/reducer.js